<template>
    <v-app id="app" class="full-height">

        <v-layout wrap class="full-height">

            <div style="
                height: 100%;
                width:100%;
                min-height: 100%;
                display: flex;
                flex-direction: column;
            ">

                <ToolBar login v-on:login="login=true"/>

                <v-content style="width:100%; flex: 1 1 auto;overflow-y: auto;overflow-x: hidden;">
                    <router-view v-on:login="openLogin"></router-view>
                </v-content>

                <Footer/>

                <v-navigation-drawer
                        v-model="login"
                        fixed app right
                        temporary
                        width="500">
                    <LoginDrawer ref="logindrawer" v-on:close="closeLogin" :onlyLogin="onlyLogin"/>
                </v-navigation-drawer>

            </div>

        </v-layout>

    </v-app>
</template>

<script>

    import Footer from "./components/Footer";
    import ToolBar from "./components/ToolBar";

    import { VApp, VLayout, VContent, VNavigationDrawer } from 'vuetify/lib'
    import LoginDrawer from "@/components/LoginDrawer";

    export default {
        name: 'DefaultLayout',
        components: {
            LoginDrawer,
            ToolBar,
            VApp,
            VContent,
            Footer,
            VLayout,
            VNavigationDrawer
        },
        data () {
            return {
                login: false,
                onlyLogin: false,
            }
        },
        created() {
            this.$root.$on('show-login', (options) => {
                this.login=true;
                this.$refs.logindrawer.goLogin(options);
            });
            this.$root.$on('show-register', (options) => {
                this.login=true;
                this.$refs.logindrawer.goRegister(options);
            });
            this.$root.$on('show-login-drawer', (event) => {
                this.login=true;
                this.$refs.logindrawer.setEmail(event.email);
            });
            if (this.$route.name === 'login') {
                this.login = true;
                this.onlyLogin = true;
            }
        },
        methods: {
            goHome() {
                this.$router.push({name: 'root', replace: true})
            },
            goLogin() {
                this.$router.push({name: 'login', replace: true})
            },
            openLogin(){
                this.login=true;
            },
            closeLogin(){
                this.login=false;
            },
        },
    };
</script>

<style scoped>
    .logo-title {
        font-size: 24px;
        font-weight: bold;
        padding: 5px 10px;
        cursor: pointer;
    }
</style>